/**
 * Option 1 (IP-15178): when Parent is locked and launch context did not set a type,
 * lock Type to the sole compatible option. Explicit lockedTypeId always wins.
 */
export function resolveEffectiveLockedTypeId(lockedTypeId, isParentLocked, compatibleTypeOptionIds) {
    if (lockedTypeId != null)
        return lockedTypeId;
    if (!isParentLocked)
        return null;
    if (compatibleTypeOptionIds.length === 1)
        return compatibleTypeOptionIds[0];
    return null;
}
